let locationsData = [
 {
    shopId: 'blosom',
    id: 'blosom',
    basePath: "/ktown", cssGlobalPrefix: 'pablitoschicken',
    // disabled: true, openingDate: "visit/call to order",
    label: "K-Town",
    className: 'night',
    address: ["4010 W 3rd St", "Los Angeles, CA 90020"],
    phone: "213-908-6838",
    phoneLink: "+12139086838",
    orderLink: "/ktown/order",
    lat: 34.0688264, lng: -118.3009604,
    storefrontPhoto: "https://afag.imgix.net/blosom-japanese-restaurant/blosom-ktown-storefront.png?w=600&auto=format",
    hours: [
      { day: 'ALL WEEK', hours: '11am-10pm' },
      
    ]},


    {
      id: 'blosomla',
      basePath: "/la-cienega", cssGlobalPrefix: 'pablitoschicken',
      shopId: 'blosomla',
      label: "La Cienega",
      // disabled: true, openingDate: "online ordering coming soon",
      // special: "We Moved!",
      address: ["1831 S La Cienega Blvd Ste E", "Los Angeles, CA 90035"],
      phone: "310-425-8330",
      phoneLink: "+13104258330",
      orderLink: "/la-cienega/order",
      lat: 34.0444834, lng: -118.3811341,
      storefrontPhoto: "https://afag.imgix.net/blosom-japanese-restaurant/blosom-hollywood-storefront.png?w=600&auto=format",
      // external: true,
      hours: [
        { day: 'Sun-Thu', hours: '11:00am-9:00pm (last order at 8:30pm)' },
        { day: 'Fri-Sat', hours: '11:00am-10:00pm (last order at 9:30pm)' },
      ]},
    //   {
    //     id: 'taronhollywood',
    //     disabled: true, openingDate: "online ordering coming soon",
    //     label: "Hollywood",
    //     className: 'night',
    //     address: ["4950 Hollywood Blvd", "Los Angeles, CA 90027"],
    //     phone: "323-663-4809",
    //     phoneLink: "+13236634809",
    //     orderLink: "/reseda",
    //     hours: [
    //       { day: 'Mon-Sat', hours: '7:30am-7pm' },
    //       { day: 'Sun', hours: '7:30am-4:30pm' },
  
    //     ]},
  
  ]

  export default locationsData

